import { render, staticRenderFns } from "./loudMainDetailsAddShenpi.vue?vue&type=template&id=6e85b31b&scoped=true"
import script from "./loudMainDetailsAddShenpi.vue?vue&type=script&lang=js"
export * from "./loudMainDetailsAddShenpi.vue?vue&type=script&lang=js"
import style0 from "./loudMainDetailsAddShenpi.vue?vue&type=style&index=0&id=6e85b31b&prod&scoped=true&lang=scss"
import style1 from "./loudMainDetailsAddShenpi.vue?vue&type=style&index=1&id=6e85b31b&prod&lang=css"
import style2 from "./loudMainDetailsAddShenpi.vue?vue&type=style&index=2&id=6e85b31b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e85b31b",
  null
  
)

export default component.exports